import _ from "lodash";
import Highlighter from "react-highlight-words";
import { Link } from "react-router-dom";
import { CommandItem } from "cmdk";

import { Badge } from "@/components/ui/Badge";
import { Warning20 } from "@/components/ui/SvgIcon";
import { Tooltip } from "@/components/ui/Tooltip";

import { Asset } from "@/features/assets/types";

import { ROUTES } from "@/constants/routes";
type Props = {
  asset: Asset;
  onSelect?: (to: string) => void;
  query?: string;
};
export const SearchItemAsset = ({
  asset,
  onSelect = () => {},
  query = "",
}: Props) => {
  const to = `${ROUTES.ASSETS}/${asset.assetId.chorusAssetId}`;
  const customerTripId = _.get(asset.currentTripId, "customerTripId", null);

  function renderCustomerTripId(customerTripId: string) {
    return (
      <div className="truncate text-xs font-medium text-chorus-gray-800">
        {customerTripId}
      </div>
    );
  }

  return (
    <CommandItem
      data-testid="search-item"
      onSelect={() => onSelect(to)}
      className="group relative cursor-pointer select-none items-center bg-white px-3 py-[2px] text-sm outline-none first:before:block first:before:h-[12px] first:before:w-full first:before:content-[''] last:after:block last:after:h-[12px] last:after:w-full last:after:content-['']   data-[disabled='true']:pointer-events-none data-[disabled='true']:opacity-50 [&:not(:last-child)]:mb-2"
    >
      <Link
        to={to}
        className="flex h-full  items-start rounded-md py-[7px] pl-3 pr-2 group-aria-selected:bg-[#F8FAFC]"
      >
        <div className="flex flex-1 flex-col gap-1 overflow-hidden">
          <div className=" grid grid-cols-[1fr_auto] items-center justify-between gap-1 font-sora text-sm font-medium tracking-[-0.003em] text-chorus-black-200">
            <Highlighter
              className="truncate"
              highlightClassName=" bg-chorus-teal-100 rounded-[2px] text-chorus-black-100"
              searchWords={query?.split(" ")}
              autoEscape={true}
              textToHighlight={asset.assetId.customerAssetId || ""}
            />
            <div className="flex items-center gap-[6px]">
              {customerTripId && (
                <Badge variant="sky" className="font-manrope">
                  On a Trip
                </Badge>
              )}
              {asset.hasUnresolvedAlert && (
                <Tooltip
                  content="Show Alerts"
                  placement={"top-end"}
                  className="w-fit"
                >
                  <div
                    data-testid="search-item-device-unresolved-alert"
                    className=" flex h-[20px] w-[24px]  items-center justify-center rounded-[20px] bg-chorus-red-100 pb-[1.7px] "
                  >
                    <Warning20 className="w-[17px]  fill-chorus-red-600" />
                  </div>
                </Tooltip>
              )}
            </div>
          </div>
          {customerTripId && renderCustomerTripId(customerTripId)}
        </div>
      </Link>
    </CommandItem>
  );
};
